import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Bell, CheckCheck } from "lucide-react";
import { api } from "@/lib/api";
import { PushPreferences } from "@/components/PushPanel";
import { useWalkie, notify } from "./WalkieLayout";

const PREFS = [["invites", "Voice invitations (calls)"], ["messages", "Private & group messages"], ["tips", "Tips received"],
  ["channel_invites", "Channel invitations"], ["followed", "Followers & followed members going live"]];

export default function WalkieNotifications() {
  const { me, reloadMe, reloadUnread } = useWalkie();
  const [rows, setRows] = useState(null);
  const load = () => api.get("/walkie/notifications").then((r) => setRows(r.data.notifications)).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const readAll = async () => { await api.post("/walkie/notifications/read-all"); load(); reloadUnread(); };
  const toggle = async (k) => {
    try { await api.patch("/walkie/me", { notif: { [k]: !me.profile.notif[k] } }); await reloadMe(); toast.success("Notification settings saved"); } catch (e) { notify.err(e); }
  };
  return (
    <div className="space-y-5" data-testid="walkie-notifications">
      <div className="flex items-center justify-between">
        <h1 className="font-black text-2xl flex items-center gap-2"><Bell className="w-6 h-6 text-[#FF2BD6]" /> Alerts</h1>
        <button onClick={readAll} data-testid="walkie-read-all" className="text-xs font-bold flex items-center gap-1 text-[#00F0FF]"><CheckCheck className="w-4 h-4" /> Mark all read</button>
      </div>
      {!rows ? <div className="wt-muted text-sm animate-pulse">Loading…</div> : rows.length === 0 ? <div className="wt-muted text-sm" data-testid="walkie-notif-empty">No alerts yet.</div> : (
        <div className="space-y-1.5">
          {rows.map((n) => (
            <Link key={n.id} to={n.link || "/walkie"} data-testid={`walkie-notif-${n.id}`}
              className={`wt-card rounded-xl px-3 py-2.5 block ${n.read ? "opacity-60" : "border-[#FF2BD6]/40"}`}>
              <div className="text-sm font-bold">{n.title}</div>
              <div className="text-[11px] wt-muted">{n.body} · {new Date(n.created_at).toLocaleString()}</div>
            </Link>
          ))}
        </div>
      )}
      <section className="wt-card rounded-2xl p-4 space-y-2" data-testid="walkie-notif-settings">
        <div className="font-black text-sm">Notification settings</div>
        {PREFS.map(([k, l]) => (
          <label key={k} className="flex items-center justify-between text-sm py-1 cursor-pointer">
            <span>{l}</span>
            <input type="checkbox" checked={!!me.profile.notif?.[k]} onChange={() => toggle(k)} data-testid={`walkie-notif-toggle-${k}`} className="w-5 h-5 accent-[#FF2BD6]" />
          </label>
        ))}
      </section>
      <div className="rounded-2xl overflow-hidden"><PushPreferences /></div>
      <p className="text-[10px] wt-muted">Phone notifications work on Android and desktop browsers, and on iPhone/iPad after adding JixxeoApps to your Home Screen (iOS 16.4+). Background delivery depends on your device and browser.</p>
    </div>
  );
}
